"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Confirm_1 = __importDefault(require("../Internals/Confirm"));
const Modal_1 = __importDefault(require("../Internals/Modal"));
const styled_1 = __importDefault(require("../utils/styled"));
const isChildFunction_1 = require("../utils/isChildFunction");
const sideSize = 280;
const StyledPageContent = styled_1.default("div", {
    shouldForwardProp: props => !["fill", "padding", "noPadding"].includes(props),
})(props => {
    const gridTemplateColumns = {
        main: props.fill ? "100%" : "auto",
        "main side": `auto ${sideSize}px`,
        "side main": `${sideSize}px auto`,
    }[props.areas || "main"];
    return Object.assign({ gridTemplateColumns, display: "grid", alignItems: "start", gridTemplateAreas: `"${props.areas || "main"}"`, gridGap: props.theme.space.element, width: "100%", height: "100%", minWidth: props.theme.pageSize.min, maxWidth: props.fill ? "none" : props.theme.pageSize.max }, (props.fill
        ? {}
        : {
            "::after": {
                content: '""',
                display: "block",
                height: 1,
            },
        }));
});
const Container = styled_1.default("div")({
    width: "100%",
    height: "100%",
});
const PageContent = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Modal_1.default, null, modal => (React.createElement(Confirm_1.default, null, confirm => (React.createElement(Container, null,
        React.createElement(StyledPageContent, Object.assign({}, props), isChildFunction_1.isChildFunction(children) ? children({ confirm, modal }) : children)))))));
};
exports.default = PageContent;
//# sourceMappingURL=PageContent.js.map